import React from "react";

import { Table, Input, Button, Space, Image, Popconfirm, Tag } from "antd";
import { Link } from "react-router-dom";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import Quickview from "./Quickview";
import Update from "./Update";
import Delete from "./Delete";

class RenderTable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };
  selectproduct = () => {
    this.props.setselectedproduct(true, this.props.List);
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleChange = (page, page_size) => {
    this.props.pageno.current = page;
    this.props.page_size.current = page_size;
    this.props.setReload(!this.props.reload);
    this.setState({
      current: page,
      minIndex: (page - 1) * this.props.page_size.current,
      maxIndex: page * this.props.page_size.current,
    });
  };

  render() {


    const columns = [
      {
        title: "SL",
        key: "index",
        render: (value, item, index) => {
          return this.state.current > 1
            ? (this.state.current - 1) * parseInt(this.props.page_size.current) + index + 1
            : index + 1;
        },
      },
      {
        title: "Sponsor Name",
        dataIndex: "",
        key: "x",
        render: (details) => {
          if (details.contact) {
            return details.Contact[0].name;
          }
        },
      },
      {
        title: "Contact No.",
        dataIndex: "",
        key: "x",
        render: (details) => {
          if (details.contact) {
            return details.Contact[0].phone;
          }
        },
      },
      {
        title: "Order No.",
        dataIndex: "wordrobe_number",
        key: "wordrobe_number",
        ...this.getColumnSearchProps("wordrobe_number"),
      },
      {
        title: "Issued Date",
        dataIndex: "issue_date",
        key: "issue_date",
        ...this.getColumnSearchProps("issue_date"),
      },
      {
        title: "Return Date",
        dataIndex: "delivery_date",
        key: "delivery_date",
        ...this.getColumnSearchProps("delivery_date"),
      },
      {
        title: "Total Items",
        dataIndex: "total_items",
        key: "total_items",
        align: "center",
      },
      {
        title: "Total Qty",
        dataIndex: "total_quantity",
        key: "total_quantity",
        align: "center",
      },
      {
        title: "Returned Qty",
        dataIndex: "total_returned_quantity",
        key: "total_returned_quantity",
        align: "center",
      },

      // {
      //   title: "Bill",
      //   dataIndex: "rent",
      //   key: "rent",
      // },
      // {
      //   title: "Payment",
      //   dataIndex: "payment",
      //   key: "payment",
      // },
      // {
      //   title: "Due",
      //   dataIndex: "due",
      //   key: "due",
      // },
      // {
      //   title: "Status",
      //   dataIndex: "",
      //   key: "status",
      //   ...this.getColumnSearchProps("status"),
      //   render: (details) => {
      //     if (details.status == "Completed") {
      //       return (
      //         <>
      //           <Tag color="green" key={details.id}>
      //             {details.status.toUpperCase()}
      //           </Tag>
      //         </>
      //       );
      //     } else if (details.status == "Delivered to sponsor") {
      //       return (
      //         <>
      //           <Tag color="red" key={details.id}>
      //             {details.status.toUpperCase()}
      //           </Tag>
      //         </>
      //       );
      //     } else {
      //       return (
      //         <>
      //           <Tag color="purple" key={details.id}>
      //             {details.status}
      //           </Tag>
      //         </>
      //       );
      //     }
      //   },
      // },
      {
        title: "Status",
        dataIndex: "",
        key: "is_returned",
        align: "center",
        render: (details) => {
          return (
            <>
              {!details.is_returned ? (
                <Tag color="red" key={details.is_returned}>
                  {"Pending".toUpperCase()}
                </Tag>
              ) : (
                <Tag color="green" key={details.is_returned}>
                  {"Returned".toUpperCase()}
                </Tag>
              )}
            </>
          );
        },
      },

      {
        title: "Action",
        dataIndex: "",
        key: "x",
        width: "22%",
        render: (details) => {
          return (
            <>
              <Update wordrobe={details} /> | <Quickview details={details} />
              {details.is_returned ? (
                <>
                  | <Delete details={details} />
                </>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
    // console.log(this.props.Auth);
    return (
      <Table
        columns={columns}
        dataSource={this.props.details.results}
        size="small"
        rowClassName={(details, index) => {
          if (details.status == "Delivered to sponsor") {
            return "rtable table_yellow";
          } else if (details.status == "Ongoing") {
            return "rtable table_light_green";
          } else if (details.status == "Completed") {
            return "rtable table_sky";
          }
        }}
        pagination={{
          defaultPageSize: this.props.page_size.current,
          current: this.state.current,
          total: this.props.details?.count,
          onChange: this.handleChange,
        }}
      />
    );
  }
}

export default RenderTable;

